import InnerComponent from '@Components/Sales/CreditNote/ViewCreditNote';
import orgContainer from '@Components/AppContainer';

const ViewCreditNote = () => ((orgContainer(InnerComponent)));
export default ViewCreditNote;
